import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { EntityAdminConfig } from 'src/shared/Baseclasses/entity-admin.component';
import { NgForm } from '@angular/forms';
import { Procedure } from 'src/shared/models/procedure.model';
import { PageLayoutService } from 'src/shared/services/page-layout.service';
import { ProcedureService } from 'src/shared/services/procedure.service';
import { Constants } from 'src/shared/utilities/constants.util';

@Component({
  selector: 'smt-procedure',
  templateUrl: './procedure.component.html',
  styleUrls: ['./procedure.component.scss']
})
export class ProcedureComponent extends EntityAdminConfig implements OnDestroy,OnInit {
    @ViewChild('procedureEditForm') public procedureEditForm: NgForm;

  enableProcedure: boolean;
  procedures: Procedure[];
  mostRecent: boolean;
  selectedName: string;
  selectedDescription: string;
  constructor(private _procedureService:ProcedureService,private _pageLayout: PageLayoutService) {
    super(_pageLayout);
  }

  ngOnDestroy() {
    super.cleanUp();
  }

  ngOnInit() {
    super.initialize(
      Constants.Procedures,
      [ "Procedure", "Description", "Last Modified" ],
      async() => this.setSelectedprocedureValues(),
      async(mostRecent: boolean) => this.refreshprocedureList(mostRecent),
      async() => this.appendprocedureList(),
      async() => this.saveprocedure(),
      () => this.setCurrentSelectionLabel(),
      () => { return "Remove"; });
  }
  async appendprocedureList(): Promise<void> {
    let result = await this._procedureService.GetProcedures(
      false,
      this.offset,
      this.itemsPerPage,
      this.searchText,
      this.selectedFilter,
      this.getSortOrderString());

    this.procedures = this.procedures.concat(result);
  }
  onAddprocedureClick() {
    this.selection = {
      id: 0,
      name: '',
      description: '',
      modifiedByUserName: '',
      modifiedDate: null
    };

    this.showAdminActionWindow = true;
    super.limitAdminActionLabel();
    this.setSelectedprocedureValues();
  }
  onCancel() {
    super.onCancel();
    this.setSelectedprocedureValues();
    this.resetForm();
  }

  onSelection(procedure: Procedure) {
      this.resetForm();
      super.onSelection(procedure);
  }
  
  async onRemoveprocedureClick() {
    if (!this.selection) {
      return;
    }

    let result = await this._procedureService.RemoveProcedure(this.selection.id);
    this.confirmModalActive =false;
    if (result) {
      super.refreshAdminList(false, false);
    }
    else {
      super.setErrorMessage("Procedure delete failed.");
    }
  }
  async refreshprocedureList(mostRecent: boolean): Promise<Procedure[]> {
    let result = await this._procedureService.GetProcedures(
      mostRecent,
      this.offset,
      this.itemsPerPage,
      this.searchText,
      this.selectedFilter,
      this.getSortOrderString());

    this.procedures = result;

    this.setSelectedprocedureValues();
    this.resetForm();

    return result;
  }
  resetForm() {
    if (!this.procedureEditForm) {
      return;
    }

    Object.keys(this.procedureEditForm.controls).forEach(control => {
      this.procedureEditForm.controls[control].markAsPristine();
    });
  }
  async saveprocedure() {
    if (!this.selection) {
      return;
    }

    let mostRecent = this.selection.id == 0;

    let selectedprocedure = new Procedure;

    selectedprocedure.id = this.selection.id;
    selectedprocedure.name = this.selectedName;
    selectedprocedure.description = this.selectedDescription;
    let result = await this._procedureService.SetProcedure(selectedprocedure);
    if (result.errorMessage) {
        super.setErrorMessage(result.errorMessage);
    }
    else if (result.id > 0) {
      this.selection.id = result.id;
      this.selection.name = result.name;
      this.selection.description = result.description;
        await super.refreshAdminList(mostRecent, true);
    }
    else {
        super.setErrorMessage("Procedure failed to save.");
    }
  }
  setCurrentSelectionLabel(): string {
    if (!this.selection) {
      return "";
    }

    if (this.selection.id == 0) {
      return "New Procedure";
    }

    return this.selection.name;
  }
  setSelectedprocedureValues() {
    super.setErrorMessage("");

    if (this.selection) {
      this.selectedName = this.selection.name;
      this.selectedDescription = this.selection.description;
      this.enableProcedure = this.selection.id == 0;
    }
    else {
      this.selectedName = "";
      this.selectedDescription = "";
      this.enableProcedure = true;
    }
  }


}
